export { default } from './HubHeaderView';



// WEBPACK FOOTER //
// ./src/components/views/HubHeaderView/index.js